
import { mapGetters } from 'vuex'
export default {
    name: 'BargainingMessageItem',
    props: {
        item: {
            type: Object,
            required: true
        },
        userId: {
            type: [Number, String],
            required: true
        },
        buttons: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapGetters({
            bargainImMessageTop: 'bargaining/bargainImMessageTop',
            bargainUserInfo: 'bargaining/bargainUserInfo'
        }),
        // 判断是否为当前用户发送的消息
        isSelf () {
            return this.userId === this.item?.uid
        },

        // 判断是否为价格卡片消息
        isPriceCard () {
            return this.item?.type === 'PRICE_CARD' ||
                (this.item?.ex && (this.item?.ex?.title || this.item?.ex?.price))
        },
        isSystemMsg () {
            return this.item?.ex?.type === 'SYSTEM_MSG'
        },

        // 获取用户头像
        userAvatar () {
            // 如果消息中包含发送者头像，优先使用
            if (this.item?.avatar) {
                return this.item.avatar
            }

            const isBuyer = this.bargainImMessageTop?.isBuyer
            const buyerHead = this.bargainImMessageTop?.bargainHeadUrl
            const sellerHead = this.bargainImMessageTop?.bargainHeadUrl

            // 简化逻辑：如果是自己的消息，显示相应身份的头像；否则显示对方身份的头像
            return (this.isSelf === isBuyer) ? buyerHead : sellerHead
        },

        // 获取消息内容
        messageContent () {
            // 处理不同格式的消息内容
            if (this.item?.content?.content) {
                return this.item.content.content
            } else if (typeof this.item?.content === 'string') {
                return this.item.content
            } else if (this.item?.text) {
                return this.item.text
            }
            return ''
        },

        // 根据状态获取背景图片
        statusBackgroundImage () {
            const status = this.item?.ex?.status || ''
            const statusIcon = this.statusIcons.find(icon => icon.code === status)
            return statusIcon ? statusIcon.url : ''
        },

        // 价格卡片的背景样式
        cardBackgroundStyle () {
            if (this.statusBackgroundImage) {
                return {
                    background: `url(${this.statusBackgroundImage}) no-repeat right 4px top 4px #ffffff`,
                    backgroundSize: '50px 50px'
                }
            }
            return {
                background: '#ffffff'
            }
        }
    },
    data () {
        return {
            // 状态图标映射表
            statusIcons: [
                {
                    url: 'https://oss.pzds.com/imweb/Mask%20group%402x.png',
                    title: '已失效',
                    code: 'EXPIRY'
                },
                {
                    url: 'https://oss.pzds.com/imweb/pig-tab-ordered%402x.png',
                    title: '已下单',
                    code: 'ORDERED'
                },
                {
                    url: 'https://oss.pzds.com/imweb/pig-tab-counter-offer%402x.png',
                    title: '已还价',
                    code: 'BARGAIN_ALREADY_MADE'
                },
                {
                    url: 'https://oss.pzds.com/imweb/pig-tab-Rejected%402x.png',
                    title: '已拒绝',
                    code: 'REJECT'
                },
                {
                    url: 'https://oss.pzds.com/mobileV3/isAgree.png',
                    title: '已同意',
                    code: 'AGREED'
                }

            ]
        }
    }
}
